import React from 'react';
import { Star, GitFork, Eye, BookOpen } from 'lucide-react';
import { Button } from './ui/Button';
import { ContributionGraph } from './ContributionGraph';
export function Hero() {
  return <section className="bg-white border-b border-[#d0d7de] pt-8 pb-12 md:py-16 px-4 md:px-6" data-id="element-113">
      <div className="max-w-[1280px] mx-auto grid md:grid-cols-12 gap-8 items-center" data-id="element-114">
        {/* Left Content */}
        <div className="md:col-span-7 lg:col-span-6 space-y-6" data-id="element-115">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-[#f6f8fa] border border-[#d0d7de] text-sm text-[#57606a] mb-2" data-id="element-116">
            <span className="flex h-2 w-2 rounded-full bg-[#216e39]" data-id="element-117"></span>
            Available for new projects
          </div>

          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-[#24292f] tracking-tight leading-tight" data-id="element-118">
            Building software that <span className="text-[#0969da]" data-id="element-119">ships</span>
          </h1>

          <p className="text-lg md:text-xl text-[#57606a] max-w-xl leading-relaxed" data-id="element-120">
            Full-stack development agency specializing in modern web
            applications, cloud infrastructure, and scalable systems.
          </p>

          <div className="flex flex-wrap gap-4 pt-2" data-id="element-121">
            <Button variant="primary" size="lg" className="font-bold" data-id="element-122">
              Start a Project
            </Button>
            <Button variant="default" size="lg" className="font-bold" data-id="element-123">
              View Our Work
            </Button>
          </div>

          {/* Stats Row - Styled like Repo Stats */}
          <div className="flex flex-wrap gap-6 pt-6 border-t border-[#d0d7de] mt-6" data-id="element-124">
            <div className="flex items-center gap-2 text-[#57606a] hover:text-[#0969da] cursor-pointer transition-colors" data-id="element-125">
              <BookOpen size={18} data-id="element-126" />
              <span className="font-bold text-[#24292f]" data-id="element-127">127</span>
              <span className="text-sm" data-id="element-128">projects</span>
            </div>
            <div className="flex items-center gap-2 text-[#57606a] hover:text-[#0969da] cursor-pointer transition-colors" data-id="element-129">
              <Star size={18} data-id="element-130" />
              <span className="font-bold text-[#24292f]" data-id="element-131">45</span>
              <span className="text-sm" data-id="element-132">happy clients</span>
            </div>
            <div className="flex items-center gap-2 text-[#57606a] hover:text-[#0969da] cursor-pointer transition-colors" data-id="element-133">
              <Eye size={18} data-id="element-134" />
              <span className="font-bold text-[#24292f]" data-id="element-135">99%</span>
              <span className="text-sm" data-id="element-136">on-time</span>
            </div>
          </div>
        </div>

        {/* Right Content - Decorative Graph */}
        <div className="md:col-span-5 lg:col-span-6 flex justify-center md:justify-end relative" data-id="element-137">
          <div className="relative z-10 bg-white p-4 border border-[#d0d7de] rounded-lg shadow-sm max-w-full overflow-hidden" data-id="element-138">
            <div className="flex items-center justify-between mb-2 text-xs text-[#57606a]" data-id="element-139">
              <span className="font-semibold" data-id="element-140">
                contributions in the last year
              </span>
              <span data-id="element-141">2,496 total</span>
            </div>
            <ContributionGraph data-id="element-142" />
          </div>

          {/* Decorative elements behind */}
          <div className="absolute -top-6 -right-6 w-full h-full border-2 border-[#d0d7de] rounded-lg -z-10 hidden md:block opacity-50" data-id="element-143"></div>
          <div className="absolute -bottom-6 -left-6 w-full h-full border-2 border-dashed border-[#d0d7de] rounded-lg -z-10 hidden md:block opacity-50" data-id="element-144"></div>
        </div>
      </div>
    </section>;
}